import { environment } from "@/environments/environment";

// AUTHENTICATION
export const LOGIN = "/login";
export const LOGIN_MFA = "/login/mfa";
export const SIGNUP = "/signup";
export const SIGNUP_CHOICE = "/signup-choice";
export const SIGNUP_EMAIL = "/signup/email";
export const SIGNUP_EMAIL_CONFIRMATION = "/signup/email/confirmation";
export const SIGNUP_SOCIAL_NETWORK_CONFIRMATION =
  "/signup/social-network/confirmation";
export const PASSWORD_RECOVERY = "/password/recovery";
export const PASSWORD_RECOVERY_CONFIRMATION = "/password/recovery/confirmation";
export const PASSWORD_RESET = "/password/reset";
export const PASSWORD_RESET_SUCCESS = "/password/reset/success";
export const LOGOUT = "/login?logout=true";

// NPC
export const HOME = "/";
export const WELCOME = "/welcome";

// CONSULTATION
export const CONSULTATION = "/catalog/*";
export const CALENDAR = "calendar";
export const CONSULTATIONS_LIST = "consultations";
export const CONSULTATION_BY_ID = "consultations/:id";
export const CONSULTATION_CREATION = "consultations/creation";
export const CONSULTATION_CONFIGURATION_CREATION = "configuration/creation";
export const CONSULTATION_CALENDAR_SETUP = "configuration/calendar";
export const CONSULTATION_AVAILABILITY_SETUP = "configuration/availability";
export const CONSULTATION_EDIT = "consultations/edit/:id";
export const CONSULTATION_CONFIRMATION = "configuration/confirmation";
export const CONSULTATION_CALENDAR_CALLBACK = "calendar/oauthcallback";

export const BOOKINGS_LIST = "bookings";

// PROFILE
export const PROFILE = "/profile";
export const PROFILE_EDITION = "/profile/edit";
export const VIEW_POST = "/posts/:id";

// POST
export const POST = "/post/*";
export const POST_CONFIGURATION = "configuration";
export const POST_MYM_CLOUD = "mym-cloud";
export const POST_MYM_CLOUD_COLLECTIONS = "mym-cloud/collections";
export const POST_MYM_CLOUD_COLLECTION = "mym-cloud/collections/:id";
export const POST_CONFIRMATION = "confirmation";
export const POST_UPDATE = "/:id/edit";
export const POST_UPDATE_CONFIRMATION = "/:id/confirmation";

// PUSH
export const PUSH = "/push/*";
export const PUSH_CONFIGURATION = "configuration";
export const PUSH_UPDATE = "/:id/edit";
export const PUSH_UPDATE_CONFIRMATION = "/:id/confirmation";
export const PUSH_UPDATE_RECAP = "/:id/recap";
export const PUSH_MYM_CLOUD = "mym-cloud";
export const PUSH_MYM_CLOUD_COLLECTIONS = "mym-cloud/collections";
export const PUSH_MYM_CLOUD_COLLECTION = "mym-cloud/collections/:id";

export const PUSH_CONFIRMATION = "confirmation";
export const PUSH_RECAP = "recap";

// LIVE
export const LIVE_CONFIGURATION = "/live/configuration";
export const CREATOR_LIVE_REDIRECT = (bookingId: string) =>
  `${environment.creatorUrl}/redirect/bookings/${bookingId}`;

// APP
export const TOOLS = "/tools";

// STUDIO & SETTINGS (creators.mym.com — in-app index pages)
export const STUDIO = "/studio";
export const SETTINGS_INDEX = "/reglages";

// CATALOG (consultation feature — in-app)
export const CATALOG_CONSULTATIONS = "/catalog/consultations";
export const CATALOG_CALENDAR = "/catalog/calendar";
export const CATALOG_BOOKINGS = "/catalog/bookings";

// LEGAL
export const TERMS_OF_SALE = "/app/tos";
export const TERMS_OF_USE = "/app/terms-of-use";
export const PRIVACY = "/app/privacy";

export const CREATOR_CHAT = `${environment.creatorUrl}/chat`;
// Legacy monolith chat, still reachable from the new chat's migration banner.
export const CREATOR_OLD_CHAT = `${environment.creatorUrl}/myms`;
export const CREATOR_CHAT_PRIVATE_GALLERY_MONOLITH = (chatId: number) =>
  `${environment.creatorUrl}/chat/${chatId}/private-gallery`;
export const CREATOR_PROFILE = `${environment.creatorUrl}/profile`;
export const CREATOR_PUSH_HISTORY = `${environment.creatorUrl}/account/broadcast-chats-history`;

// CHAT
export const CHAT = "/chat"; // List of chats
export const CHAT_DETAIL = "/chat/:userId"; // Chat detail

// PRIVATE MEDIA
export const PRIVATE_MEDIA_CONFIGURATION = "configuration";
export const PRIVATE_MEDIA_MYM_CLOUD = "mym-cloud";
export const PRIVATE_MEDIA_MYM_CLOUD_COLLECTIONS = "mym-cloud/collections";
export const PRIVATE_MEDIA_MYM_CLOUD_COLLECTION = "mym-cloud/collections/:id";
export const PRIVATE_MEDIA_RECAP = "recap";
export const PRIVATE_MEDIA_CONFIRMATION = "confirmation";
export const MESSAGING = "/messaging"; // List of messages inside message interface
export const MESSAGING_DETAIL = "/messaging/:userId"; // Message detail inside message interface

// PLAYLIST
export const PLAYLISTS = `/v2${TOOLS}/playlists`;
export const PLAYLIST = `/v2${TOOLS}/playlists/:id`;

// MYMCLOUD
export const MYM_CLOUD = "/mym-cloud";
export const MYM_CLOUD_COLLECTIONS = "/mym-cloud?tab=collections";
export const MYM_CLOUD_COLLECTION = "/mym-cloud/collections/:id";

// SUPPORT
export const REPORT_FAN_URL =
  "https://support.mym.fans/hc/fr/requests/new?ticket_form_id=18170257246748";

// MEDIAS
export const MEDIAS = "/medias/:id";
